<template>
	<div class = "tabbar-div">
		<van-row type="flex" justify="space-between">
		  <van-col span="12">
			  <div class = "tabbar-item tabbar-item-1" >
			  	<img src="../../assets/home.jpg"/>
			  	<span @click = "toHome()">点餐首页</span>
			  </div>
		  </van-col>
		  <van-col span="12">
			  <div class = "tabbar-item">
			  	<img src="../../assets/order_2.jpg"/>
			  	<span @click = "toHistoryOrder()">我的订单</span>
			  </div>
		  </van-col>
		</van-row>
	</div>
</template>

<script>
	import {Col, Row} from 'vant';
	export default {
		name: 'ComTabbar',
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row
		 },
		data(){
			return {
			}
		},
		methods:{
			toHome(){
				this.$router.push("home");
			},
			toHistoryOrder(){
				this.$router.push("historyOrder");
			}
		}
	}
</script>

<style scoped>
	.tabbar-div {
		padding: 10px 0;
		position: fixed;
		width: 100%;
		height: auto;
		bottom: 0px;
		left: 0px;
		background-color: #ffffff;
		box-shadow: 0 2px 10px #c5c5c5;
		border-top-color: #c5c5c5;
	}
	
	.tabbar-item-1{
		border-right: #ff0000  1px solid;
		border-image: linear-gradient(#fbfbfb,#333333,#fbfbfb) 0 3 0 0;
		border-top: none;
	}
	
	.tabbar-item {
		padding: 6px;
		width: 100%;
		font-size: 15px;
		text-align: center;
	}
	.tabbar-item>img {
		width: 28px;
		height: 28px;
		margin-right: 7px;
		vertical-align:middle;
	}
	
	.tabbar-item span {
		vertical-align:middle;
	}
	
</style>
